import { SVGProps } from 'react';

const SvgRadioChecked = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
        <rect width={12} height={12} x={4} y={4} rx={6} />
        <rect width={19} height={19} x={0.5} y={0.5} rx={9.5} />
    </svg>
);
export default SvgRadioChecked;
